<template>
    <div class="projectList">
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>HTML5项目</el-breadcrumb-item>
            <el-breadcrumb-item>查询项目</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="position:relative;left:-29.4rem;margin-bottom:3px;">
            <el-button  type="info" @click="reverseList">反向排序</el-button>
        </div>
        <el-table class="project-list-table" :data="projectList" stripe border>
            <el-table-column label="项目ID" align='center' width="100px">
                <template scope="scope">
                    <span>{{scope.row.id}}</span>
                </template>
            </el-table-column>
            <el-table-column label="项目名称" align='center'>
                <template scope="scope">
                    <span>{{scope.row.projectName}}</span>
                </template>
            </el-table-column>
            <el-table-column label="项目经理" align='center'  width="120px">
                <template scope="scope">
                    <span>{{scope.row.userName}}</span>
                </template>
            </el-table-column>
            <el-table-column label="所属大区" align='center'  width="200px">
                <template scope="scope">
                    <span>{{scope.row.company}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align='center'>
                <template scope="scope">
                    <el-button size="small" type="info" @click="openLink(scope.row.link)">查看</el-button>
                    <el-button size="small" type="danger" @click="deleteProject(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--分页器-->
        <!--<el-pagination class="page-control" layout="prev, pager, next" :total="projectListLength" @current-change=“”></el-pagination>-->
        <!--end-->
    </div>
</template>
<script>
import CONFIG from "@/config/index.js";
import TOOL from '@/tool/index.js';
import router from "@/router/index.js";
export default {
    name: "projectList",
    data() {
        return {
            projectList: null,
            projectListLength: 0
        };
    },
    mounted(){
        this._init();
    },
    methods: {
        _getProjectList() {
            this.$http.get(CONFIG.HOST + "/yysj/list" + '?t=' + TOOL.getCurrentTime()).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.projectList = result.data;
                    this.projectListLength = this.projectList.length || 0;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response)=>{
                console.log(response);
            });
        },
        _confirmMessage(message, success = ()=>{}, cancel = ()=>{}) {
            this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(success).catch(cancel);          
        },
        reverseList(){
            this.projectList = this.projectList.reverse()
        },
        openLink(projectUrl){
            window.open(projectUrl);
        },
        deleteProject(projectId) {
            this._confirmMessage('是否确定删除projectId=' + projectId + '的HTML5项目？', ()=>{
                if (projectId < 0) {
                    this.$notify.error({
                        message: '【营销平台】是否确定删除projectId=' + projectId + '的HTML5项目不存在'
                    });
                    return;
                }
                this.$http.delete(CONFIG.HOST + '/yysj/deleteItem/' + projectId).then((response)=>{
                    let result = response.body;
                    if (result && result.status === 1) {
                        this._getProjectList();
                    } else {
                        this.$notify.error({
                            message: result.message
                        });
                    }
                },(response)=>{
                    console.log(response);
                });
            });
        },
        changePage(page){

        },
        _init() {
            this._getProjectList();
        }
    }
};
</script>
<style lang="less">
    .projectList{
        width: 98%;
        margin: 0 auto;
        .bread-nav{
            margin: 20px 0;
        }
        .project-list-table{
            min-width: 980px;
        }
        .page-control{
            margin: 20px auto 0 auto;
        }
    }  
</style>


// WEBPACK FOOTER //
// List.vue?0b2e8034